export const getPriceImpact = (amount: string | number, theBestAmount: string | number): string =>
  ((100 - (Number(amount || 1) * 100) / Number(theBestAmount || 1)) * 100000).toFixed(0) || '0'
